import axios from 'axios'

export const PostInqury = (data, params, headers) => axios.post(` https://api.technolee.com/API/T/AddEditContactUs`, data, { params, headers });
export const PostProjectInqury = (data, params, headers) => axios.post(` https://api.technolee.com/API/T/AddEditInquiry`, data, { params, headers });
export const PostApply = (data, params, headers) => axios.post(` https://api.technolee.com/API/T/AddEditCareer`, data, { params, headers });
